import getUrl from "../getUrl";
import _ from "lodash";

export default async function isAdmin() {
  const data = await fetch(getUrl(`/api/v1/check`), {
    credentials: 'include',
  })
  const json = await data.json()
  return _.get(json, 'data.ok') == 'ok'
}



// WEBPACK FOOTER //
// ./src/text/isAdmin.js